export class ButtonDownload {
  constructor(el) {
    this.el = el
    this.button = el.querySelector('.e-button')
    this.documentsContainer = el.querySelector('.c-button-download__documents')
    this.header = el.querySelector('.c-button-download__documents__header')
    this.documents = Array.from(el.querySelectorAll('.c-button-download__documents__document')).map((item) => ({
      el: item,
      header: item.querySelector('.c-button-download__documents__document__header')
    }))
    this.isOpen = false

    this.init()
  }

  init() {
    this.button.addEventListener('click', () => {
      if (this.isOpen) {
        this.button.classList.remove('--open')
        this.documentsContainer.classList.remove('--visible')
        this.isOpen = false
        this.documentsContainer.removeEventListener('wheel', (e) => e.stopPropagation())

        setTimeout(() => {
          this.documentsContainer.style.visibility = 'hidden'
        }, 400)
      } else {
        this.button.classList.add('--open')
        this.documentsContainer.style.visibility = 'visible'
        this.documentsContainer.classList.add('--visible')
        this.isOpen = true
        this.documentsContainer.addEventListener('wheel', (e) => e.stopPropagation())
      }
    })

    this.header.addEventListener('click', () => {
      if (this.header.classList.contains('--sub-open')) {
        this.documents.forEach(({el}) => {
          el.classList.remove('--open')
          this.header.classList.remove('--sub-open')

          if (Array.from(el.querySelectorAll('a')).length > this.documents.length) {
            this.header.classList.remove('--scroll')
          }
        })
      }
    })

    this.documents.forEach(({header, el}) => {
      header.addEventListener('click', () => {
        this.header.classList.add('--sub-open')
        el.classList.add('--open')

        if (Array.from(el.querySelectorAll('a')).length > this.documents.length) {
          this.header.classList.add('--scroll')
        }
      })
    })
  }
}

export default function createButtonDownload(config) {
  return new ButtonDownload(config)
}
